import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// A 401 outside the auth flow means the session is gone (expired cookie,
// reseeded database, revoked user) — send the person to the login page
// instead of letting every in-flight request explode as an uncaught error.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const path = window.location.pathname;
    const onLoginPage = path === "/login" || path === "/admin";
    if (status === 401 && !onLoginPage && !url.includes("/auth/")) {
      // Staff pages send an expired session back to the separate admin login.
      window.location.assign(path.startsWith("/staff") ? "/admin" : "/login");
      // Swallow the burst of parallel 401s that follow the first one —
      // the page is navigating away anyway.
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
